import { Project, ProjectOption } from '../../types/noocoDbTypes';
import { ProjectSimulatorPatchBodyRequest } from '../../types/noocoTypes';
import { ProjectZone } from '../../types/noocoTypes'
import { SuccessReturnBody, getSuccessReturnBody, BadRequestReturnBody, getBadRequestReturnBody } from '../general';

export const projectSimulatorBadRequestReturnMessage = "Simulator project already exists";
export const projectFromProjectSimulatorBadRequestReturnMessage = "Missing arguments to create project from simulator project";
export const projectSimulatorMissingDataReturnMessage = "Simulator project not found";

export interface ProjectSimulator extends Project {
  ProjectOption: ProjectOption;
  Zones: ProjectZone[];
};

export interface ProjectSimulatorPatchRequest {
  Body: ProjectSimulatorPatchBodyRequest;
}

export interface ProjectFromProjectSimulatorPostRequest {
  Body: {
    name: string,
    companyId: number
  }; 
}

export function postProjectSimulatorSuccess(createdProjectSimulator: ProjectSimulator): SuccessReturnBody {
  return getSuccessReturnBody(createdProjectSimulator);
}

export function postProjectFromProjectSimulatorSuccess(createdProjectId: number): SuccessReturnBody {
  return getSuccessReturnBody(createdProjectId);
}

export function getProjectSimulatorSuccess(projectSimulator: ProjectSimulator): SuccessReturnBody {
  return getSuccessReturnBody(projectSimulator);
}

export function patchProjectSimulatorSuccess(patchedProjectSimulator: ProjectSimulator): SuccessReturnBody {
  return getSuccessReturnBody(patchedProjectSimulator);
}
export function postProjectSimulatorBadRequest(): BadRequestReturnBody {
  return getBadRequestReturnBody(projectSimulatorBadRequestReturnMessage);
}

export function postProjectFromProjectSimulatorBadRequest(): BadRequestReturnBody {
  return getBadRequestReturnBody(projectFromProjectSimulatorBadRequestReturnMessage);
}
